import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
export class ReservationDriverAttachmentDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.reservationId = initializer.reservationId;
        this.role = initializer.role;
        this.type = initializer.type;
        this.imageUrl = initializer.imageUrl;
    }
}
